import React, {useEffect, useState} from "react";
import MyAccountInformation from "../../../components/MyAccountInformation/MyAccountInformation";
import ResetPassword from "../../../components/ResetPassword/ResetPassword";
import MyAccountBalance from "../../../components/MyAccountBalance/MyAccountBalance";
import AddressForm from "../../../components/MyAddress/AddressForm";
import useMyProfileVM from "./useMyProfileVM";
import {FormattedMessage} from "react-intl";

import "./MyProfileView.style.scss";
import useDeviceType from "../../../hooks/useDeviceType";
import {selectUserAccountProfileState} from "../../../stores/account/account.selectors";
import {useDispatch, useSelector} from "react-redux";
import useAppModalService from "../../../hooks/useAppModalService";
import UserAccountUpdatedPopUp from "../../PopUps/UserAccountUpdateSuccess/UserAccountUpdatedPopUp";
import {resetUserAccountProfileState} from "../../../stores/account/account.slice";
const MyProfileView = () => {
    const vm = useMyProfileVM();
    const {isMobile} = useDeviceType()
    const userAccountProfileState = useSelector(selectUserAccountProfileState);
    const {openModal} = useAppModalService();
    const dispatch = useDispatch();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect( () => {
        if(userAccountProfileState.updated){
             openModal('userAccountUpdated', 'info', {
                title: <FormattedMessage id={`popUp.${userAccountProfileState.eventName}.title`}/>,
                subtitle: <FormattedMessage id={`popUp.${userAccountProfileState.eventName}.subTitle`}/>,
                modalComponent: UserAccountUpdatedPopUp,
                onClose: () => {
                    dispatch(resetUserAccountProfileState());
                },
                onOk: () => {
                    dispatch(resetUserAccountProfileState());
                }
            });
        }

    }, [userAccountProfileState.updated]);

    return (
        <div className="MyProfileView">
            <div className="myProfileTitle gold-gradient-text" >
                <FormattedMessage id={"myAccountView.myProfile.title"}/>
            </div>
            <div className={"myProfileContent"}>
                {(isMobile) && <MyAccountBalance />}
                    <MyAccountInformation vm={vm}/>
                    <ResetPassword vm={vm}/>
                {(!isMobile) && <MyAccountBalance/>}
                    <AddressForm vm={vm}/>
            </div>
            <div className="saveProfileButton" onClick={vm.handleSaveChanges}>
                <FormattedMessage id={"myAccountView.myProfile.saveChanges"}/>
            </div>
        </div>
    );
}

export default MyProfileView;